<script>
    import { handleLogout } from '$lib/app/lib.js';

    let {
        show_signup = $bindable(false),
        show_login = $bindable(false),
        session = null,
    } = $props();
</script>
{#if session?.id}
    <div class="navbar-item has-dropdown is-hoverable">
        <div class="buttons my-2">
            <a class="navbar-link" href="/user/{session.userpage}">
                <svg class='svg-icon is-big'><use xlink:href='/i/fa.svg#person-walking-luggage'></use></svg>&nbsp;<span>{session?.accountname}</span>
            </a>
        </div>  

        <div class="navbar-dropdown is-boxed is-right">
            <a class="navbar-item" href="/user/{session.userpage}">
                My Map
            </a>
            <a class="navbar-item" href="/user/{session.userpage}?t=settings">
                Map Settings
            </a>
            <a class="navbar-item" href="/settings">
                Profile Settings
            </a>
            <hr class="navbar-divider"/>
            <a class="navbar-item" href="/logout?" onclick={handleLogout}>
                Log Out
            </a>
        </div>
    </div>
{:else}
    <div class="navbar-item">
        <div class="buttons">
            <button class="button is-primary" href="/signup" onclick={(e)=>{e.preventDefault(); show_signup = true; show_login = false}}>
                <strong>Sign up</strong>
            </button>
            <button class="button is-link" href="/login" onclick={(e)=>{e.preventDefault; show_signup = false; show_login = true}}>
                Log in
            </button>
        </div>
    </div>
{/if}
